<div class="flex flex-col flex-1 w-full h-full">
  <mat-expansion-panel
    class="w-full cursor-default"
    [expanded]="isExpandedByDefault"
    [disabled]="!isExpandable"
    (opened)="onOpen($event)"
    (closed)="onClose($event)"
    (afterCollapse)="onAfterCollapse($event)"
  >
    <mat-expansion-panel-header
      class="bg-project-600"
      [ngClass]="{
        'hover:cursor-default': !isExpandable,
        'hover:contrast-[1.05]': isExpandable
      }"
      data-testid="header"
      [collapsedHeight]="headerHeight"
      [expandedHeight]="headerHeight"
    >
      <mat-panel-title class="min-w-0 space-x-3 text-project-2400">
        <ng-container *ngIf="!headerRef.hasChildNodes()">
          <i class="text-inherit icon" [ngClass]="iconClass"></i>
          <h3 class="text-sm text-inherit whitespace-nowrap">{{ title }}</h3>
        </ng-container>

        <div
          [ngClass]="{ hidden: !headerRef.hasChildNodes() }"
          class="flex w-full h-11"
          #headerRef
        >
          <ng-content select="[header]"> </ng-content>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="flex" [ngClass]="" data-testid="expandedContent">
      <ng-content select="[expandedContent]"></ng-content>
    </div>
  </mat-expansion-panel>
  <div
    class="flex pb-0 bg-project-2200"
    [ngClass]="{ 'mat-expansion-panel-body': ref.hasChildNodes() }"
    @fadeInOpacity
    data-testid="notExpandedContent"
    *ngIf="!isExpanded"
    (click)="openPanel()"
    #ref
  >
    <ng-content select="[notExpandedContent]"></ng-content>
  </div>
</div>
